export const environment = {
    production: false,
    stage: 'DEV',
    APP_URL: 'https://prueba.rumapp.cl',
    API_URL: 'https://anfitriones-api-prueba.rumapp.cl',
    MAPS_KEY: 'AIzaSyAyD8QPuPuJOtSjSQKjaIDJq9zmDOOdE6I',
    MAP_ID: '6c312989e23b9eda'
};
